(ns core.front.analytics
  "Website activity tracking through Matomo or Pendo. Script loading and initialization is done in index.clj.")

(defn track-page-view [{:keys [path]}]
  (when-let [tracker (.-_paq js/window)]
    (doto tracker
      (.push #js ["setCustomUrl" path])
      (.push #js ["setDocumentTitle" (.-title js/document)])
      (.push #js ["trackPageView"]))))

(defn set-user-id
  [user]
  (when user
    (when-let [pendo (.-pendo js/window)]
      (doto pendo
        (.initialize (clj->js {:visitor {:id    (:user/email user)
                                         :role  (cond
                                                  (->> user
                                                       :user/authority-groups
                                                       (some :group-admin?)) "group-admin"
                                                  (:user/authority? user) "authority"
                                                  (:user/stakeholder? user) "stakeholder"
                                                  :else "public")
                                         :roles (->> user
                                                     :user/authority-groups
                                                     (mapcat :group-roles)
                                                     distinct)}
                               :account {:id (:account user)}}))))
    (when-let [tracker (.-_paq js/window)]
      (doto tracker
        (.push #js ["setUserId" (:db/id user)])))))
